import { render } from "./Upload.vue?vue&type=template&id=579bcf2c&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=579bcf2c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-579bcf2c"

export default script